<template lang="">
  <div style="background-color:#f9f9f9;height:100vh">
      <van-nav-bar title="我的成绩" left-arrow @click-left="onClickLeft"/>
      <div style="margin:10px;border-radius:15px;background-color:white;padding:1px 10px">
          <div>
              <h3><span style="border:2px solid red;margin-right:5px"></span>报读信息</h3>
              <div>
                 <div class="flex">
                      <div class="item">专业</div>
                      <div  class="item">{{couseAchievement.specialtyName}}</div>
                 </div>
                 <div class="flex">
                      <div  class="item">最低毕业学分：{{couseAchievement.byXf}}</div>
                      <div  class="item">已修学分：<span style="color:red">{{couseAchievement.yxXf}}</span></div>
                 </div>
              </div>
          </div>
      </div>
      <div style="padding:1px 10px;font-size:12px;color:red">
          <span>
              线上课程分为考试课和考查课，均采取线上测验的终结性考试方式。题型均为客观题，考题内容包含各章节知识点，考卷从题库中随机抽取生成。
          </span>
      </div>
      <div style="padding:1px 10px;margin:10px">
          <h3><span style="border:2px solid red;margin-right:5px"></span>课程成绩</h3>
      </div>
      <div class="couseAchievement">
          <table border style="border-collapse: collapse;">
              <tr>
                  <td>课程名称</td>
                  <td>学分</td>
                  <td>进度</td>
                  <td>考查形式</td>
                  <td>课程形式</td>
                  <td>成绩</td>
              </tr>
              <tr v-for="item in couseAchievement.courseList" :key="item.id">
                  <td>{{item.coursesName}}</td>
                  <td>{{item.credit}}</td>
                  <td>
                      <span v-if="item.score==0" style="color:red">0%</span>
                      <span v-else>100%</span>
                  </td>
                  <td>{{item.studyTypeName}}</td>
                  <td>{{item.testTypeName}}</td>
                  <td>
                      <span v-if="item.score==0" style="color:red">/</span>
                      <span v-else>{{item.score>=60?'合格':'不合格'}}</span>    
                  </td>
              </tr>
          </table>
      </div>
  </div>
</template>
<script>
import { getMyCouseAchievement } from '@/api/login';
export default {
  data() {
      return {
          studentNo: '',
          couseAchievement: {
              courseList: []
          },
          list: [1, 2, 3, 4, 5],
          value: 'ssss'
      }
  },
  created() {
      this.studentNo = this.$store.state.studentNo
      if (this.studentNo) {
          this.getCouseAchievement(this.studentNo);
      }
  },
  methods: {
      getCouseAchievement(studentNo) {
          getMyCouseAchievement({ studentNo }).then(res => {
              if (res) {
                  this.couseAchievement = res || {};
              }
          })
      },
      onClickLeft() {
          this.$router.go(-1)
      }
  },
}
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.flex:not(:last-child) {
  border-bottom: 1px solid #f9f9f9;
}

.flex .item {
  padding: 14px 3px;
  width: 50%;
}

.couseAchievement table {
  width: 100%;
}

.couseAchievement table tr {
  width: 100%;
}

.couseAchievement table tr:first-of-type td {
  font-weight: bold;
  background-color: #f2f2f2;
  /* color: red; */
}

.couseAchievement table tr td {
  padding: 4px 0px;
  width: calc(100%/6);
  font-weight: 400;
  font-size: 12px;
  text-align: center;
}
</style>
